import { Component, computed, input, output, ViewEncapsulation } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CakeItemVariant } from '../cake-item-variant';

/**
 * Card of a pieces group, a pieces product with several variants, or a pieces product without a quantity picker
 * that is already in the cart: "See variants" on hover, or edit / add new / remove when it is in the cart.
 */
@Component({
  standalone: true,
  selector: 'cake-item-pieces-group',
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, NgTemplateOutlet, RouterLink, TranslateModule],
  templateUrl: './cake-item-pieces-group.component.html',
})
export class CakeItemPiecesGroupComponent extends CakeItemVariant {
  cartCount = input(0);
  /** touch: the controls were revealed by a first tap */
  controlsVisible = input(false);
  /** touch with the product in the cart: the overlay takes no taps until the controls are revealed */
  touchLocked = input(false);

  open = output<void>();
  edit = output<void>();
  remove = output<void>();

  variantsCount = computed(() => this.cake().productIds?.length);
}
